import React, { useEffect, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import { toast } from 'sonner'
import { useUserPermissions, AccessFlags } from '../contexts/UserPermissionsContext'

interface Props {
  flag: keyof AccessFlags
  children: React.ReactNode
}

// Page-level access gate. Redirects to / with a toast when the user lacks the flag.
// Ready = permissions loaded AND View As restore complete.
const AccessGate: React.FC<Props> = ({ flag, children }) => {
  const navigate = useNavigate()
  const { accessFlags, isLoadingAccessFlags, isLoadingOverride } = useUserPermissions()
  const toastedRef = useRef(false)

  const ready = !isLoadingAccessFlags && !isLoadingOverride
  const allowed = accessFlags[flag]

  useEffect(() => {
    if (!ready) return
    if (!allowed && !toastedRef.current) {
      toastedRef.current = true
      toast.error("You don't have access to this page")
      navigate('/', { replace: true })
    }
    if (allowed) toastedRef.current = false
  }, [ready, allowed, navigate])

  if (!ready || !allowed) return null
  return <>{children}</>
}

export default AccessGate
